(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["merchdude-card-colors"] && !Shopify.designMode) return;
  try {
    if (!window.merchdudeCardColorsReady) {
    window.merchdudeCardColorsReady = true;

    const colorSelector = '[data-md-card-color]';
    const groupSelector = '[data-md-card-colors]';
    const cardSelector = '[data-js-product-item]';

    const enableColors = (root) => {
      if (!(root instanceof Element) && root !== document) return;
      if (root.matches?.(colorSelector)) root.disabled = false;
      root.querySelectorAll(colorSelector).forEach((button) => { button.disabled = false; });
    };

    const nativeColorGroup = (card, colors) => {
      const picker = card.querySelector('quick-buy product-variants');
      return picker?.querySelectorAll('[data-js-product-variant]')[Number(colors.dataset.colorIndex)];
    };

    const updateLink = (card, variantId) => {
      const link = card.querySelector('.product-item__invisible-link');
      if (!link || !variantId) return;
      const url = new URL(link.href, window.location.href);
      url.searchParams.set('variant', variantId);
      link.href = url.href;
    };

    const showColor = (button, variantId, announce = true) => {
      const colors = button.closest(groupSelector);
      const card = button.closest(cardSelector);
      const imageArea = card?.querySelector('[data-js-product-item-image]');
      if (!card || !colors) return;
      colors.querySelectorAll(colorSelector).forEach((item) => {
        item.setAttribute('aria-pressed', String(item === button));
      });
      updateLink(card, variantId || button.dataset.variantId);

      if (imageArea) {
        let preview = imageArea.querySelector('[data-md-color-preview]');
        if (!preview) {
          const original = imageArea.querySelector('figure');
          preview = document.createElement('figure');
          preview.className = 'lazy-image lazy-image--background product-item__image-figure lazyloaded';
          if (original?.classList.contains('lazy-image--fit')) preview.classList.add('lazy-image--fit');
          preview.dataset.mdColorPreview = '';
          const image = document.createElement('img');
          image.decoding = 'async';
          image.sizes = original?.querySelector('img')?.sizes || '(max-width: 767px) 50vw, 33vw';
          const missing = document.createElement('span');
          missing.className = 'merchdude-card-colors__missing-image';
          preview.append(image, missing);
          imageArea.append(preview);
        }
        const image = preview.querySelector('img');
        const missing = preview.querySelector('span');
        const hasImage = Boolean(button.dataset.colorImage);
        image.hidden = !hasImage;
        missing.hidden = hasImage;
        missing.textContent = button.dataset.imageMissing;
        image.alt = button.dataset.imageAlt;
        if (hasImage) {
          image.width = Number(button.dataset.imageWidth) || 960;
          image.height = Number(button.dataset.imageHeight) || 960;
          image.srcset = button.dataset.imageSrcset || '';
          image.src = button.dataset.colorImage;
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('src');
        }
        card.classList.add('md-color-selected');
      }

      if (announce) {
        const status = colors.querySelector('[data-md-color-status]');
        if (status) status.textContent = button.dataset.colorImage
          ? button.dataset.selectedMessage
          : button.dataset.imageMissing;
      }
    };

    const syncQuickBuyColor = (button) => {
      const colors = button.closest(groupSelector);
      const card = button.closest(cardSelector);
      const nativeGroup = nativeColorGroup(card, colors);
      if (!nativeGroup) return;
      const input = [...nativeGroup.querySelectorAll('input[type="radio"]')]
        .find((item) => item.value === button.dataset.colorName);
      const select = nativeGroup.querySelector('select');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (select && select.value !== button.dataset.colorName) {
        const option = [...select.options].find((item) => item.value === button.dataset.colorName);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const label = nativeGroup.querySelector('.product-variant__item-text-label');
      if (label) label.textContent = button.dataset.colorName;
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest?.(colorSelector);
      if (!button) return;
      event.preventDefault();
      showColor(button);
      syncQuickBuyColor(button);
    });

    document.addEventListener('keydown', (event) => {
      const button = event.target.closest?.(colorSelector);
      if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const buttons = [...button.closest(groupSelector).querySelectorAll(colorSelector)];
      let index = buttons.indexOf(button);
      const direction = getComputedStyle(button).direction === 'rtl' ? -1 : 1;
      if (event.key === 'ArrowLeft') index -= direction;
      if (event.key === 'ArrowRight') index += direction;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = buttons.length - 1;
      event.preventDefault();
      const next = buttons[(index + buttons.length) % buttons.length];
      next.focus();
      next.click();
    });

    document.addEventListener('change', (event) => {
      const picker = event.target.closest?.('quick-buy product-variants');
      const card = picker?.closest(cardSelector);
      const colors = card?.querySelector(groupSelector);
      if (!colors) return;
      const group = nativeColorGroup(card, colors);
      const name = group?.querySelector('input:checked, select')?.value;
      const button = [...colors.querySelectorAll(colorSelector)].find((item) => item.dataset.colorName === name);
      if (button) showColor(button);
    });

    document.addEventListener('VARIANT_CHANGE', (event) => {
      const picker = event.target;
      if (!picker.matches?.('quick-buy product-variants')) return;
      const card = picker.closest(cardSelector);
      const colors = card?.querySelector(groupSelector);
      const variant = picker.currentVariant;
      if (!colors || !variant) return;
      const index = Number(colors.dataset.colorIndex);
      const name = variant.options?.[index];
      const chosenName = nativeColorGroup(card, colors)?.querySelector('input:checked, select')?.value;
      if (!chosenName || name !== chosenName) return;
      const button = [...colors.querySelectorAll(colorSelector)].find((item) => item.dataset.colorName === name);
      if (button) showColor(button, variant.id, false);
    }, true);

    enableColors(document);
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach(enableColors));
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  } catch(e) { console.error(e); }
})();

})();
